import styled from '@emotion/styled';
import { spacing } from '@naf/theme';
import { Grid } from '@naf/grid';

export const StyledGrid = styled(Grid)<{ topMargin?: boolean }>`
  margin-top: ${({ topMargin }) => (topMargin ? spacing.space40 : 0)};
`;

export const TitleWrapper = styled.div`
  margin-bottom: ${spacing.space16} !important;
`;

export const TermsConsent = styled.div`
  margin-top: ${spacing.space32};
  margin-bottom: 0;
  display: flex;
  align-items: baseline;
  flex-direction: column;
`;

export const TermsConsentText = styled.span`
  white-space: pre-wrap;
`;
